<template>
  <div class="forgot-password">
    <div class="container">
      <div class="flex justify-center">
        <div class="w-full max-w-md mx-auto">
          <div class="card">
            <div v-if="success" class="p-12 rounded-b-lg">
              <h1 class="mb-2 text-2xl font-bold">Reset link sent</h1>
              <p>We've sent an email to</p>
              <p class="font-bold">{{ form.email || 'your@email.address' }}</p>
              <p class="mt-3">Follow the instructions in that email to setup your new password.</p>
            </div>
            <div class="p-12" v-else>
              <div class="mb-6">
                <h1 class="mb-2 text-2xl font-bold">Reset your password</h1>
                <p>Enter your email address and we'll email you a link to change your password.</p>
              </div>
              <form @submit.prevent="forgotPassword()">
                <fieldset class="mt-4 form-group">
                  <label class="form-label">Email Address</label>
                  <input id="email" class="py-3 form-input" placeholder="Email Address" v-model="form.email">
                </fieldset>
                <button type="submit" class="w-full mb-2 btn btn-lg btn-primary" v-submitting="submitting">
                  Send Password Reset Link
                </button>
              </form>
            </div>
          </div>
          <div class="my-8 text-center">
            <router-link :to="{ name: 'Login' }">&larr; Back to Log in</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForgotPassword',

  metaInfo: {
    title: 'Forgot Password'
  },

  mounted () {
    this.$refs.initial.focus()
  },

  data () {
    return {
      submitting: false,
      success: false,
      form: {
        email: this.$route.query.email
      }
    }
  },

  methods: {
    async forgotPassword () {
      try {
        this.submitting = true
        this.form.email = this.form.email.toLowerCase()
        await this.$api.post('auth/forgot-password', this.form)
        this.success = true
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>

</style>
